import { User } from "api/gen/entities";
import { createContext } from "react";

const AccountContext = createContext<User | null>(null)

export default AccountContext;